import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './_components/error/error.component';
import { TrimbleErrorComponent } from './_components/error/trimble.error.component';
import { FeeDetailsComponent } from './fee-details/fee-details.component';
import { FeePaymentModule } from './fee-payment/fee-payment.module';
import { HomeComponent } from './home';
import { TrimbleFeeDetailsComponent } from './trimble-fee-details/trimble-fee-details.component';
import { TrimbleFeePaymentModule } from './trimble-fee-payment/trimble-fee-payment.module';

import { MbenzErrorComponent } from './_components/error/mbenz.error.component';
import { QrErrorComponent } from './_components/error/qr.error.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { MbenzFeeDetailsComponent } from './mbenz-fee-details/mbenz-fee-details.component';
import { MbenzFeePaymentModule } from './mbenz-fee-payment/mbenz-fee-payment.module';
import { QrFeeDetailsComponent } from './qr-fee-details/qr-fee-details.component';
import { QrFeePaymentModule } from './qr-fee-payment/qr-fee-payment.module';
import { FormatDataComponent } from './format-data/format-data.component';
import { PayStudentComponent } from './fee-payment/pay-student.component';

const feeModule = () =>
  import('./fee-payment/fee-payment.module').then((x) => FeePaymentModule);
const trimbleFeeModule = () =>
  import('./trimble-fee-payment/trimble-fee-payment.module').then(
    (x) => TrimbleFeePaymentModule
  );
const homeModule = () =>
  import('./home/home.module').then((x) => HomeComponent);
const qrFeeModule = () =>
  import('./qr-fee-payment/qr-fee-payment.module').then(
    (x) => QrFeePaymentModule
  );
const mbenzFeeModule = () => import('./mbenz-fee-payment/mbenz-fee-payment.module').then((x) => MbenzFeePaymentModule);

const routes: Routes = [
  { path: 'bmw', component: FeeDetailsComponent },
  { path: 'trimble', component: TrimbleFeeDetailsComponent },
  //{ path: 'envista', redirectTo: 'Envista', pathMatch: 'full' },
  { path: 'Envista', component: QrFeeDetailsComponent },
  { path: 'mbenz', component: MbenzFeeDetailsComponent },
  { path: 'jpmc', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },

  { path: 'error', component: ErrorComponent },
  { path: 'trimbleError', component: TrimbleErrorComponent },
  { path: 'qrError', component: QrErrorComponent },
  { path: 'mbenzError', component: MbenzErrorComponent },

  { path: 'payment', loadChildren: feeModule },
  { path: 'trimblePayment', loadChildren: trimbleFeeModule },
  { path: 'qrPayment', loadChildren: qrFeeModule },
  { path: 'mbenzPayment', loadChildren: mbenzFeeModule },
  { path: 'format-data', component: FormatDataComponent },
  { path: '', component: PayStudentComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'payment', loadChildren: feeModule },

  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
